var generic = generic || {};

(function ($) {
  Drupal.behaviors.giftcardBalanceV1 = {
    attach: function (context) {
      var $template = $('.js-giftcard-balance-v1', context);
      var $giftCardBalanceFormContainer = $('.js-giftcard-balance-form', $template);
      var $errListNode = $('.js-error-messages', $giftCardBalanceFormContainer);
      var $checkBalanceSubmit = $('.js-giftcard-submit', $giftCardBalanceFormContainer);
      var $remainingBalance = $('.js-giftcard-balance-amount', $template);
      var $balanceNode = $('.js-balance-info', $template);

      $checkBalanceSubmit.once().on('click', function (e) {
        e.preventDefault();
        var paramObj = {};
        var inputVals = $giftCardBalanceFormContainer.serializeArray();

        $.each(inputVals, function (index, formObj) {
          paramObj[formObj.name] = formObj.value;
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [paramObj],
          onSuccess: function (jsonRpcResponse) {
            var data = jsonRpcResponse.getData();
            var balanceAmount = data.formatted_balance;

            if (balanceAmount !== null) {
              $remainingBalance.text(balanceAmount);
              $balanceNode.removeClass('hidden');
              generic.hideErrors($errListNode, $giftCardBalanceFormContainer);
            }
          },
          onFailure: function (jsonRpcResponse) {
            var errorObjectsArray = jsonRpcResponse.getMessages();

            generic.showErrors(errorObjectsArray, $errListNode, $giftCardBalanceFormContainer);
            $balanceNode.addClass('hidden');
          }
        });
      });
    }
  };
})(jQuery);
